import { getApiBaseUrl } from './env';

const CSRF_COOKIE = 'csrfToken';

// The backend issues this cookie (non-httpOnly, unlike the auth cookies) on
// any request that doesn't already have one — read it and echo it back as a
// header on state-changing requests. A cross-site attacker's page can trigger
// the request and it'll carry the cookie automatically, but it can't read
// the cookie's value to put in the header, so the double-submit fails for them.
export function getCsrfToken(): string | null {
  if (typeof document === 'undefined') return null;
  const match = document.cookie.match(/(?:^|; )csrfToken=([^;]*)/);
  return match ? decodeURIComponent(match[1]) : null;
}

// Don't assume some other page load already triggered a GET that set the
// cookie — on a brand new session the very first request can be a mutating
// one (e.g. hitting /login directly), which would otherwise 403 forever.
export async function ensureCsrfToken(): Promise<string | null> {
  const existing = getCsrfToken();
  if (existing) return existing;
  try {
    await fetch(`${getApiBaseUrl('/api')}/health`, { credentials: 'include' });
  } catch {
    // ignore — the mutating request this was priming for will fail
    // downstream with a clear error if the backend is truly unreachable
  }
  return getCsrfToken();
}

export const CSRF_HEADER = 'X-CSRF-Token';
export { CSRF_COOKIE };
